export default function CheckedIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="23" cy="23" r="23" fill="#11A75C" />
      <path
        d="M34.6644 15.2092L30.978 12.2308C30.5916 11.9188 30.018 11.9788 29.7036 12.3676L19.6428 24.8284L15.702 21.2476C15.3324 20.9092 14.7564 20.9404 14.4204 21.3076L11.2356 24.8116C10.8996 25.1812 10.926 25.7572 11.2956 26.0932L19.7196 33.7516C20.0892 34.0876 20.646 34.0444 20.9604 33.6556L23.9316 29.95C23.9364 29.9452 23.9364 29.938 23.9412 29.9284L34.8012 16.4836C35.1132 16.0972 35.0508 15.5212 34.6644 15.2092Z"
        fill="white"
      />
    </svg>
  );
}
